import classNames from "classnames/bind";
import { Link } from "react-router-dom";
import Button from "../../../components/Button/Button";
import { CheckSuccesIcon } from "../../../components/Icons/Icons";
import HeaderRegister from "../HeaderRegister";
import styles from './WellcomeContainer.module.css';
import PropTypes from "prop-types";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { actions } from "../../../store";

const cx = classNames.bind(styles);

function WellcomeContainer({ back, title, description }) {
    // eslint-disable-next-line
    const [state, dispatch] = useStoreContext()

    const handleClickToLogin = () => {
        dispatch(actions.setDataRegister({ userName: '', email: '', password: '' }))
        dispatch(actions.setTokenUser(''))
        dispatch(actions.setEmailForgotPassword(''))
    }
    return (
        <>
            <HeaderRegister header={' '} backTo={back} />
            <div className={cx('register-succes')}>
                <div className={cx("border-stock")}>
                    <div className={cx('tick-icon')}><CheckSuccesIcon /></div>
                </div>
                <p className={cx('title')}>{title}</p>
                <p className={cx('desc')}>{description}</p>
                <Link className={cx('submit-button')} to={'/login'} onClick={handleClickToLogin}>
                    <Button
                        title="Đăng nhập"
                        onClick={() => { return 0 }}
                    />
                </Link>
            </div>
        </>
    )
}



WellcomeContainer.propTypes = {
    back: PropTypes.string,
    title: PropTypes.string.isRequired,
    forgotPass: PropTypes.bool,
}

export default WellcomeContainer